import { Component, OnInit, HostBinding, Output, EventEmitter } from '@angular/core';
import { ServiceService } from '../service/service.service';
import { CTType } from '../../element/service/recordview-param';

@Component({
	selector: 'common-conditional-template-runner',
	templateUrl: './conditional-template-runner.component.html',
	styleUrls: ['./conditional-template-runner.component.scss']
})
export class ConditionalTemplateRunnerComponent implements OnInit {
	// ä¸èµ·åconditional-templateçåå æ¯elementä¸­çè®¾ç½®çé¢ï¼å·²ç»ç¨äºè¯¥åç§°
	@HostBinding('class.conditional-template-runner') hostClass = true;
	@Output() enterPress = new EventEmitter();
	readonly typeInput = CTType.Input;
	readonly typeSelect = CTType.Select;
	readonly typeRangeInput = CTType.RangeInput;
	readonly typeMultiSelect = CTType.MultiSelect;
	readonly typeSilder = CTType.Slider;
	constructor(public svr: ServiceService) {}

	ngOnInit() {}
	reset() {
		this.svr.data.conditionalTemplates.forEach(v => {
			v.Data.Value = undefined;
			v.enable = false;
		});
	}
}
